(function () {
  'use strict';
  // Preserve the fallback page in theme previews and when explicitly requested.
  var params = new URLSearchParams(window.location.search);
  if (params.has('preview_theme_id') || params.get('redirect') === '0' || (window.Shopify && window.Shopify.designMode)) return;
  var ua = navigator.userAgent || '';
  var platform = navigator.platform || '';
  var apple = /iPhone|iPad|iPod/i.test(ua) || (/MacIntel|Macintosh/i.test(platform + ' ' + ua) && navigator.maxTouchPoints > 1);
  var android = /Android/i.test(ua);
  var link = document.getElementById(apple ? 'verify-download-apple' : android ? 'verify-download-google' : '');
  if (!link) return;
  var status = document.getElementById('verify-app-download-status');
  if (status) status.textContent = 'Apertura dello store… Se non si apre, premi il pulsante qui sotto.';
  // Only redirect to our two fixed, visible store links. No user-controlled destination.
  window.location.replace(link.href);
})();
